import { useState } from 'react';

import { Divider, Link, Menu, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import BookOpenIcon from '@/components/Icons/BookOpenIcon';
import BoxIcon from '@/components/Icons/BoxIcon';
import ChevronDownIcon from '@/components/Icons/ChevronDownIcon';
import CpuIcon from '@/components/Icons/CpuIcon';
import LinkIcon from '@/components/Icons/LinkIcon';
import ToolIcon from '@/components/Icons/ToolIcon';
import { links } from '@/localization';
import { BasetenPageEnum } from '@/routes';
import { MenuItem } from '@/sections/Sidebar/styled';

import { AppLink, getAppLinkStyles } from '../../styled';
import { useBudgetExceededSnackbar } from './Budget/useBudgetExceededSnackbar';
import Credits from './Credits';
import HelpMenu from './HelpMenu';
import PaymentOverdue from './PaymentOverdue';
import UserMenu from './UserMenu';

function LoggedIn() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  useBudgetExceededSnackbar();

  return (
    <Stack gap={1} direction="row" alignItems="center">
      <Credits />
      <PaymentOverdue />

      <Stack direction="row" alignItems="center" gap={0.5}>
        <Button
          onClick={(event) => setAnchorEl(event.currentTarget)}
          variant="outlined"
          endIcon={<ChevronDownIcon />}
          sx={{ maxHeight: 31 }}
        >
          New
        </Button>
        <HelpMenu />
        <UserMenu />
      </Stack>
      <Menu
        open={isMenuOpen}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Typography variant="h6" color="secondary" sx={{ mx: 1, my: 1 }}>
          Explore
        </Typography>
        <MenuItem>
          <Link
            sx={(theme) => getAppLinkStyles(theme)}
            href={links.basetenModelLibrary}
            target="_blank"
          >
            <BookOpenIcon color="secondary" /> Model library
          </Link>
        </MenuItem>

        <MenuItem>
          <AppLink page={BasetenPageEnum.CreateSharedEndpoint}>
            <BoxIcon color="secondary" /> Model APIs
          </AppLink>
        </MenuItem>
        <Divider sx={{ mx: -1 }} />
        <Typography variant="h6" color="secondary" sx={{ mx: 1, mt: 1.5, mb: 1 }}>
          Deploy
        </Typography>
        <MenuItem>
          <Link
            sx={(theme) => getAppLinkStyles(theme)}
            href={links.basetenDocsDeployingYourFirstModel}
            target="_blank"
          >
            <CpuIcon color="secondary" /> Model
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            sx={(theme) => getAppLinkStyles(theme)}
            href={links.basetenDocsChainsOverview}
            target="_blank"
          >
            <LinkIcon color="secondary" />
            Chain
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            sx={(theme) => getAppLinkStyles(theme)}
            href={links.basetenDocsTrainingOverview}
            target="_blank"
          >
            <ToolIcon color="secondary" />
            Training job
          </Link>
        </MenuItem>
      </Menu>
    </Stack>
  );
}

export default LoggedIn;
